// List of all external URLs used in this project
export const URL_FACEBOOK = 'https://www.facebook.com/WagWalking';
export const URL_INSTAGRAM = 'https://instagram.com/wag';
export const URL_TIKTOK = 'https://www.tiktok.com/@wag';
export const URL_TWITTER = 'https://twitter.com/wagwalking';

export enum Urls {
  Investors = 'https://www.sec.gov/edgar/browse/?CIK=1842356&owner=exclude',
}

export enum ServiceUrls {
  Boarding = 'https://wagwalking.com/dog-boarding',
  DropIn = 'https://wagwalking.com/drop-ins',
  Sitting = 'https://wagwalking.com/dog-sitting',
  Training = 'https://wagwalking.com/dog-training',
  Premium = 'https://wagwalking.com/wag-premium',
  Walking = 'https://wagwalking.com/dog-walking',
  WellnessPlans = 'https://wagwalking.com/wag-wellness/wellness-plans?utm_source=wag-co&utm_medium=web',
  Maxbone = 'https://www.maxbone.com/',
  PetInsurer = 'https://quote.petinsurer.com/quote/ref=wag?utm_source=wag-co&utm_medium=web',
  Petted = 'https://www.petted.com?utm_source=wag-co&utm_medium=web',
  DogFoodAdvisor = 'https://www.dogfoodadvisor.com',
  CatFoodAdvisor = 'https://www.catfoodadvisor.com',
}

export enum VideoUrls {
  ProductOverview = 'https://www.youtube.com/embed/FQoVFhIEGEw',
}
